<template>
  <div class="gameplay-tunein text3">
    <p>{{msg}}</p>
  </div>
</template>

<script>
function isDateBefore(date) {
  return date.getTime() > new Date().getTime();
}

export default {
  computed: {
    msg() {
      const isPrior = isDateBefore(new Date("2020-06-16"));
      return isPrior
        ? "PREMIERES JUNE 16TH AT 8/7c ON MTV"
        : "TUESDAYS AT 8/7c ON MTV ";
    }
  }
};
</script>

<style lang="scss" scoped>
.gameplay-tunein {
  text-align: center;
  text-transform: none;
}
</style>
